import { FilestackImageBlur, FilestackImageFit } from 'types/Filestack';
import { configValue } from 'utils/config';
import { imageUrl } from 'utils/filestack';

import { identityFilter } from './functional';

type Props = {
  handle: string;
  width?: number;
  height?: number;
  fit?: FilestackImageFit;
  blur?: FilestackImageBlur;
  format?: string;
  mimetype?: string;
  quality?: number;
};

export function getImageSrc({
  handle,
  width,
  height,
  fit,
  blur,
  format,
  mimetype,
  quality,
}: Props): string {
  const resize = [
    width && `w:${Math.round(width)}`,
    height && `h:${Math.round(height)}`,
  ]
    .filter(identityFilter)
    .join(',');

  const resizeQuery = resize && `resize=${resize}${fit ? `,fit:${fit}` : ''}`;
  const qualityQuery = `quality=value:${quality || 70}`;
  const formatQuery = format && `output=format:${format}`;
  const blurQuery = blur && `blur=amount:${blur}`;

  const transform = [resizeQuery, qualityQuery, formatQuery, blurQuery]
    .filter(Boolean)
    .join('/');

  return imageUrl({ handle, mimetype, transform });
}

export function getStaticImageSrc(filePath: string): string {
  const imagesPath = configValue('idealist', 'staticImgPath');
  return `${imagesPath}${filePath}`;
}
